<div class="p-4 md:p-6">
  <div class="mb-4 flex items-center gap-3">
    <button
      class="grid h-9 w-9 place-content-center rounded-full hover:bg-gray-100 dark:hover:bg-white/10"
      (click)="goBack()"
      aria-label="Volver"
    >
      <svg class="h-5 w-5 text-gray-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M15 18l-6-6 6-6" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
    <h2 class="text-2xl font-bold text-[#0e1726] dark:text-white">Analíticas del vehículo</h2>
  </div>

  <app-vehicle-analytics-panel [vehicleId]="vehicleId"></app-vehicle-analytics-panel>
</div>
